//export const API_URL: string = 'http://localhost:8081/api';
export const API_URL: string = 'https://api.linkpay.vn/api';